// extracted by mini-css-extract-plugin
export default {"link-wrap":"social-media-links_link-wrap__WGL9+","link":"social-media-links_link__YHj4I","icon":"social-media-links_icon__2+X-3"};